import React from "react";

export default function IndeterminateCheckBox(props) {
  const indeterminateCheck = React.useCallback((elem) => {
    if (elem) {
      elem.indeterminate = props.indeterminate;
    }
  });

  const { type, ref, indeterminate, checked, onChange, ...retProps } = props;

  return (
    <input
      type="checkbox"
      ref={indeterminateCheck}
      onChange={onChange ? onChange : () => {}}
      checked={checked ? checked : false}
      {...retProps}
    />
  );
}
